const AMERICAS = [
  "AG", "AR", "BS", "BB", "BZ", "BO", "BR", "CA", "CL", "CO", "CR", "CU", "DM", "DO", "EC", "SV", "GD", "GT", "GY", "HT",
  "HN", "JM", "MX", "NI", "PA", "PY", "PE", "PR", "KN", "LC", "VC", "SR", "TT", "US", "UY", "VE", "AW", "CW",
];

const LOCALES = { es: "es", en: "en", pt: "pt" };

export const getCountries = (lang) => {
  const locale = LOCALES[lang] || "es";
  const dn = new Intl.DisplayNames([locale], { type: "region" });
  return AMERICAS.map((code) => ({ code, name: dn.of(code) })).sort((a, b) => a.name.localeCompare(b.name, locale));
};
